import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';

import { EmptyState } from '../../states/index.js';
import TruthFactCard from './TruthFactCard.jsx';

import { FileSignature } from 'lucide-react';

/**
 * One section of Truth (CT-5719): Deal commitments, Other facts or Canon, and
 * its facts. Canon is always drawn, with its own empty state while nothing
 * signed has been filed (in a dashed box, as in the prototype); an empty Deal
 * commitments or Other facts is left out.
 */
const TruthSection = memo(function TruthSection({ section, entityTitle, selectedId, requestingIds, onOpen, onRequestChange }) {
  const { t } = useTranslation('unified-profiles');
  const isCanon = section.key === 'canon';

  if (!section.facts.length && !isCanon) return null;

  return (
    <section data-testid="truth-section" data-section={section.key} className="flex flex-col gap-3">
      <h2 className="text-xs font-semibold uppercase tracking-wide text-content-muted">
        {t(`knowledge.truth.sections.${section.key}`)}
      </h2>
      {section.facts.length ? (
        <div className="flex flex-col gap-3">
          {section.facts.map((fact) => (
            <TruthFactCard
              key={fact.id}
              fact={fact}
              selected={fact.id === selectedId}
              busy={requestingIds.has(fact.id)}
              onOpen={onOpen}
              onRequestChange={onRequestChange}
            />
          ))}
        </div>
      ) : (
        <div data-testid="canon-empty" className="rounded-lg border border-dashed border-edge">
          <EmptyState
            testId="canon-empty-state"
            icon={FileSignature}
            title={t('knowledge.truth.canonEmpty.title')}
            subtitle={t('knowledge.truth.canonEmpty.subtitle', { name: entityTitle ?? t('profile.untitled') })}
          />
        </div>
      )}
    </section>
  );
});

export default TruthSection;
